
import FreeShipping from "../component/freeshipping";
import EmploymentForm from "../component/EmployForm"
import Breadcrumb from "../component/Breadcrumb";
import PageTitle from "../component/pageTitle";

function EmploymentFormPage()
{

    return(
        <>

        <PageTitle title="فرم استخدام"/>
        <Breadcrumb />
        <EmploymentForm  />
        <FreeShipping />
        
        </>
    );


}
export default EmploymentFormPage;